import {
  Button,
  Card,
  Checkbox,
  Divider,
  Drawer,
  Dropdown,
  Form,
  Input,
  Layout,
  Modal,
  Pagination,
  Radio,
  Select,
  Switch,
  Table,
  Tabs,
  Tag,
  Upload,
} from 'antd';
import styled, { createGlobalStyle, keyframes } from 'styled-components';
const { Dragger } = Upload;
// Add this GlobalStyle component
export const GlobalTheme = createGlobalStyle`
  /* @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap'); */
  @import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
  body{
    //font-family: ${({ theme }) => theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"} !important;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
  }
`;
export const Theme = {
  colors: {
    /*white: '#FFFFFF',
    bodyBg: '#F7F5F0',
    primary: '#2E45DA', // using for primary color as blue
    secondary: '#2C2926', // using for secondary color as black
    greenColor: '#1D7C18', // using for tertiary color as green
    blueColor: '#346DD5', // using for quaternary color as blue
    textColor: '#6D6A67', // using for gray text color
    borderColor: '#E2E8EE', // using for card border color
    tagBg: '#81FF9E', // dashboard Total Responses tags background color
    rgbPrimary: '11, 69, 83', // using for primary color as rgba
    rgbOrange: '216, 146, 43', // using for orange color as rgba
    rgbaGray: '240, 240, 240', // using for gray color as rgba
    tagPrimary: '76, 80, 89', // using for project tag primary color as rgba
    gradientBg: 'linear-gradient(90deg, #0B4553 0%, #199AB9 100%)', // using for gradient background color
    imgFilterColor:
      'brightness(0) saturate(100%) invert(19%) sepia(68%) saturate(655%) hue-rotate(146deg) brightness(94%) contrast(92%)', //img color filter
    imgFilterWhite:
      'brightness(0) saturate(100%) invert(100%) sepia(5%) saturate(47%) hue-rotate(125deg) brightness(116%) contrast(100%);', //img color white filter
   */
    },
  settings: {
    bodyBg: '#F7F5F0', //body background color
    borderColor: '#E2E8EE', // using for card border color
    borderColorLight: '#f0f0f0', // using for light border color
    primary: '#2C2926', // using for primary color as dark blue
    secondary: '#485066', // sidebar menu default color
    textColor: '#6D6A67', // using for light gray text color
    switchOffTextColor: '#4B5563', // readable text for unchecked switch labels
    whiteColor: '#FFFFFF', // using for white color
    blueColor: '#34B3F1', // using for blue color
    blueDarkColor: '#5F42DE', // using for blue dark color
    orangeColor: '#E65B5B', // using for orange color
    cyanColor: '#00B8BA', // using for cyan color
    mainColor: '#2E45DA', // using for question title color
    gradientBg: 'linear-gradient(180deg, #2E45DA 0%, #2E45DA 100%)', // using for gradient background color
    gradientBg2: 'linear-gradient(90deg, #0B4553 0%, #199AB9 100%)', // using for gradient background color
    greenColor: '#1D7C18', // using for green color
    cardHeaderBg: '#EDEEF3', // using for card header background color
    mainBorderColor: '#ECEAF0', // using for new border color
    ctaBorderColor: '#F5F4F7',
    borderActiveColor: '#D0CBDB',
    subTitleColor: '#38363D',
    infoColor: '#747378',
    tagBg: '#81FF9E', // dashboard Total Responses tags background color
    rgbPrimary: '11, 69, 83', // using for primary color as rgba
    rgbOrange: '216, 146, 43', // using for orange color as rgba
    rgbaGray: '240, 240, 240', // using for gray color as rgba
    tagPrimary: '76, 80, 89', // using for project tag primary color as rgba
    lightText:'#999999', // Light color for chat vox and cat panel
    gradientBorder:
      'linear-gradient(white, white) padding-box,  linear-gradient(90deg, #e0aaff, #ffb3ba) border-box', // using for gradient background color
    // imgFilterColor:
    //   'brightness(0) saturate(100%) invert(8%) sepia(48%) saturate(5112%) hue-rotate(256deg) brightness(89%) contrast(103%)', //img color filter
    imgFilterColor:
      'brightness(0) saturate(100%) invert(9%) sepia(29%) saturate(254%) hue-rotate(349deg) brightness(95%) contrast(83%)', //img color filter (blue #2E45DA)
    imgFilterWhite:
      'brightness(0) saturate(100%) invert(100%) sepia(5%) saturate(47%) hue-rotate(125deg) brightness(116%) contrast(100%);', //img color white filter

    // update color on 06.07.2026
    cta_hover:'linear-gradient(93deg, #2E45DA 10.15%, #749ACC 130.39%)', //  CTA Buttons Hover background 


  },
  fonts: {
    inter: `'Montserrat', sans-serif`,
    poppins: `'Poppins', sans-serif`,
  },
};
export const ThemeLayout = styled(Layout)`
  background: none !important;
  /* No bottom margin (was 15px since the first commit): the page card is
     exactly one screen tall (min-height calc(100vh - 32px) + the 16px page
     padding top and bottom), so the margin collapsed through #root and body
     and made every page scroll by 15px behind the always-on html scrollbar
     (user 2026-09-29). Long pages keep the page container's 16px bottom
     padding. */
  margin-bottom: 0;
`;
// new style
export const ThemeButton = styled(Button)`
  font-family: ${({ theme }) =>
    theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"} !important;
  border: 1px solid ${({ theme }) => theme.settings.mainColor} !important;
  color: ${({ theme }) => theme.settings.whiteColor} !important;
  box-shadow: none !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 14px !important;
  padding: 10px 20px !important;
  transition: all 0.2s ease;
  background: ${({ theme }) => theme.settings.cta_hover} !important;
  img,
  svg {
    color: ${({ theme }) => theme.settings.whiteColor};
    filter: ${({ theme }) => theme.settings.imgFilterWhite};
  }
  &:active {
    transform: scale(0.95);
  }
  &:hover:not(:disabled) {
    touch-action: manipulation;
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    border: 1px solid ${({ theme }) => theme.settings.mainColor} !important;
    color: ${({ theme }) => theme.settings.primary} !important;
    img,
    svg {
      color: ${({ theme }) => theme.settings.mainColor};
      filter: ${({ theme }) => theme.settings.imgFilterColor};
    }
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    &:active {
      transform: none;
    }
  }
  &.noBackground {
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    border: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
    color: ${({ theme }) => theme.settings.primary} !important;
    transition: all 0.2s ease;
    font-weight: 500 !important;
    &:active {
      transform: scale(0.95);
    }
    img,
    svg {
      color: ${({ theme }) => theme.settings.primary};
      filter: ${({ theme }) => theme.settings.imgFilterColor};
    }
    &:hover {
      background: ${({ theme }) => theme.settings.cta_hover} !important;
      border: 1px solid transparent!important;
      color: ${({ theme }) => theme.settings.whiteColor} !important;
      img,
      svg {
        color: ${({ theme }) => theme.settings.whiteColor};
        filter: ${({ theme }) => theme.settings.imgFilterWhite};
      }
    }
  }
  &.btnBorder {
    border: 1px solid ${({ theme }) => theme.settings.primary} !important;
  }
  &.ghostPurple {
    background: rgba(46, 69, 218, 0.08) !important;
    border: none !important;
    color: ${({ theme }) => theme.settings.primary} !important;
    font-weight: 500 !important;
    &:hover {
      background: rgba(46, 69, 218, 0.15) !important;
      color: ${({ theme }) => theme.settings.primary} !important;
    }
  }
  &.solidPurple {
    background: #2E45DA !important;
    border: none !important;
    color: ${({ theme }) => theme.settings.whiteColor} !important;
    font-weight: 600 !important;
    &:hover {
      background: #243AB8 !important;
      color: ${({ theme }) => theme.settings.whiteColor} !important;
    }
  }
  &.danger {
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    color: ${({ theme }) => theme.settings.orangeColor} !important;
    border: 1px solid ${({ theme }) => theme.settings.orangeColor} !important;
    svg,
    img {
      color: ${({ theme }) => theme.settings.orangeColor} !important;
      filter: brightness(0) saturate(100%) invert(76%) sepia(70%) saturate(4850%) hue-rotate(320deg)
        brightness(90%) contrast(100%);
    }
    &:hover {
      background: ${({ theme }) => theme.settings.orangeColor} !important;
      border: 1px solid ${({ theme }) => theme.settings.orangeColor} !important;
      color: ${({ theme }) => theme.settings.whiteColor} !important;
      svg,
      img {
        color: ${({ theme }) => theme.settings.whiteColor} !important;
        filter: ${({ theme }) => theme.settings.imgFilterWhite} !important;
      }
    }
  }
  &.loginBtn {
    width: 100%;
    background: ${({ theme }) => theme.settings.gradientBg} !important;
    color: ${({ theme }) => theme.settings.whiteColor} !important;
    box-shadow: 0px 4px 26px rgba(0, 0, 0, 0.25) !important;
    border-radius: 10px !important;
    border: 1px solid transparent;
    &:hover {
      background: ${({ theme }) => theme.settings.gradientBg} !important;
      color: ${({ theme }) => theme.settings.whiteColor} !important;
      opacity: 0.85;
      border: 1px solid ${({ theme }) => theme.settings.primary} !important;
    }
  }
  &.syncBtn {
    background: #1b8844 !important;
    border: 1px solid rgba(27, 136, 68, 0.2) !important;
    border-radius: 10px !important;
    color: ${({ theme }) => theme.settings.whiteColor} !important;
    padding: 6px 10px !important;
  }
  &.link {
    height: auto;
    padding: 0px !important;
    font-weight: 600 !important;
    background: transparent !important;
    border: none !important;
    color: ${({ theme }) => theme.settings.primary} !important;
    svg,
    img {
      color: ${({ theme }) => theme.settings.primary} !important;
      filter: ${({ theme }) => theme.settings.imgFilterColor} !important;
    }
    &:hover {
      background: transparent !important;
      border: none !important;
      color: ${({ theme }) => theme.settings.primary} !important;
      svg,
      img {
        color: ${({ theme }) => theme.settings.primary} !important;
        filter: ${({ theme }) => theme.settings.imgFilterColor} !important;
      }
    }
  }
  /* &.grayBackground {
      background: rgba(
      ${({ theme }) => theme.settings.rgbPrimary},
      0.05
    ) !important;
    border: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
    color: ${({ theme }) => theme.settings.mainColor} !important;
    img,
    svg {
      color: ${({ theme }) => theme.settings.mainColor};
      filter: ${({ theme }) => theme.settings.imgFilterColor};
    }
    &:hover {
      background: ${({ theme }) => theme.settings.mainColor} !important;
      border: 1px solid ${({ theme }) => theme.settings.mainColor} !important;
      color: ${({ theme }) => theme.settings.whiteColor} !important;
      img,
      svg {
        color: ${({ theme }) => theme.settings.whiteColor} !important;
        filter: ${({ theme }) => theme.settings.imgFilterWhite} !important;
      }
    }
    &:active {
      transform: scale(0.95);
    }
  } */
  &.isMobile {
    width: auto !important;
    padding: 0px !important;
  }
  &.fullWidth {
    width: 100% !important;
    text-align: left;
    justify-content: space-between !important;
  }
  &.noRadius {
    border-radius: 5px !important;
  }
`;
// new style
export const ThemeFilterBtn = styled(Button)`
  font-family: ${({ theme }) =>
    theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"} !important;
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  font-size: 14px !important;
  font-weight: 500 !important;
  transition: all 0.2s ease;
  /* color: ${({ theme }) => theme.settings.primary} !important; */
  color: ${({ theme }) => theme.settings.primary} !important;
  &:active {
    transform: scale(0.95);
  }
  svg,
  img {
    font-size: 14px;
    font-weight: 800;
    filter: ${({ theme }) => theme.settings.imgFilterColor};
    color: ${({ theme }) => theme.settings.primary};
  }
  &:hover {
    background: ${({ theme }) => theme.settings.cta_hover} !important;
    border: 1px solid ${({ theme }) => theme.settings.cta_hover} !important;
    color: ${({ theme }) => theme.settings.whiteColor} !important;
    svg,
    img {
      filter: ${({ theme }) => theme.settings.imgFilterWhite} !important;
      color: ${({ theme }) => theme.settings.whiteColor};
    }
  }
  &.btnBorder {
    border: 1px solid ${({ theme }) => theme.settings.mainColor} !important;
  }
  &.btnGrayBorder {
    border: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
    box-shadow:
      0px 6px 29px rgba(89, 108, 148, 0.07),
      0px 0.751293px 3.63125px rgba(89, 108, 148, 0.035) !important;
  }
  &.fullWidth {
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 20px 15px !important;
    border-radius: 10px !important;
    font-size: 12px !important;
    line-height: 20px !important;
    font-weight: 500 !important;
    svg,
    img {
      margin-top: 5px;
      font-size: 16px !important;
    }
  }
  &.noStyle {
    border: none !important;
    cursor: default !important;
    background: rgba(${({ theme }) => theme.settings.rgbPrimary}, 0.1) !important;
    &:hover {
      transform: scale(1);
      background: transparent !important;
      color: ${({ theme }) => theme.settings.primary} !important;
      svg,
      img {
        color: ${({ theme }) => theme.settings.primary} !important;
        filter: ${({ theme }) => theme.settings.imgFilterColor} !important;
      }
    }
  }
  &.bgTransparent {
    background: transparent !important;
    &:hover {
      background: transparent !important;
    }
  }
  &.background {
    background: ${({ theme }) => theme.settings.gradientBg} !important;
    border: 1px solid ${({ theme }) => theme.settings.whiteColor} !important;
    transition: all 0.2s ease;
    color: ${({ theme }) => theme.settings.whiteColor} !important;
    &:active {
      transform: scale(0.95);
    }
    svg,
    img {
      filter: ${({ theme }) => theme.settings.imgFilterWhite};
      color: ${({ theme }) => theme.settings.whiteColor};
    }
    &:hover {
      background: ${({ theme }) => theme.settings.whiteColor} !important;
      border: 1px solid ${({ theme }) => theme.settings.primary} !important;
      color: ${({ theme }) => theme.settings.primary} !important;
      svg,
      img {
        filter: ${({ theme }) => theme.settings.imgFilterColor} !important;
        color: ${({ theme }) => theme.settings.primary};
      }
    }
  }
  &.smallFont {
    font-size: 12px !important;
    font-weight: 500 !important;
  }
  &.shadow {
    box-shadow: 0px 0px 8px rgba(50, 50, 50, 0.05);
  }
  &.danger {
    color: ${({ theme }) => theme.settings.orangeColor} !important;
    border-color: ${({ theme }) => theme.settings.orangeColor} !important;
    svg,
    img {
      color: ${({ theme }) => theme.settings.orangeColor} !important;
      filter: none !important;
    }
    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.settings.orangeColor} !important;
      border-color: ${({ theme }) => theme.settings.orangeColor} !important;
      color: ${({ theme }) => theme.settings.whiteColor} !important;
      svg,
      img {
        color: ${({ theme }) => theme.settings.whiteColor} !important;
        filter: none !important;
      }
    }
  }
`;
export const ThemeFancyCard = styled(Card)`
  width: 100%;
  position: relative;
  height: calc(100vh - 200px);
  background: transparent !important;
  border: none !important;
  /* 
  border-radius: 12px;
  border: none;
  background: transparent url("/images/card-wave-bg.svg") no-repeat bottom
    center;
  background-size: cover;
  @media (max-width: 768px) {
    height: 100% !important;
  } */
  .ant-card-body {
    padding: 0px;
  }
  &.flexWrapper {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .ant-card-body {
      width: 100%;
      position: relative;
      display: block !important;
    }
  }
`;
export const ThemeCard = styled(Card)`
  width: 100%;
  position: relative;
  height: 100%;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  background: ${({ theme }) => theme.settings.whiteColor};
  .ant-card-body {
    padding: 20px;
  }
  &.fullHeight {
    .ant-card-body {
      padding: 20px;
      min-height: calc(100vh - 180px);
    }
  }
  &.largeBody {
    .ant-card-body {
      padding: 24px;
    }
  }
  &.smallPadding {
    .ant-card-body {
      padding: 10px;
    }
  }
  .ant-card-head {
    font-family: ${({ theme }) =>
      theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"} !important;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: ${({ theme }) => theme.settings.primary};
    padding: 20px 24px 0px 24px;
    border-bottom: none;
  }
  &.backgroundColor {
    background: ${({ theme }) => theme.settings.bodyBg};
  }
  &.grayBackground {
    background: rgba(${({ theme }) => theme.settings.rgbaGray}, 1);
  }
  .smallTitle {
    font-size: 14px;
    font-weight: 400;
    line-height: 30px;
    color: ${({ theme }) => theme.settings.primary};
    @media (max-width: 768px) {
      font-size: 12px;
      line-height: 20px;
    }
  }
`;
export const ThemeTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  color: ${({ theme }) => theme.settings.primary};
  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 24px;
  }
  &.smallTitle {
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
    span {
      font-size: 14px;
      font-weight: 400;
      color: ${({ theme }) => theme.settings.primary};
    }
  }
`;

const chatTextShine = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

export const ThemePara1 = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: ${({ theme }) => theme.settings.textColor};
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
  &.darkColor {
    color: ${({ theme }) => theme.settings.primary};
    &.strong {
      font-weight: 600;
    }
  }
  &.font14 {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
  }
  &.shinyText {
    background: linear-gradient(
      90deg,
      ${({ theme }) => theme.settings.textColor || '#b5b5b5'} 0%,
      ${({ theme }) => theme.settings.textColor || '#b5b5b5'} 40%,
      rgba(255, 255, 255, 0.9) 50%,
      ${({ theme }) => theme.settings.textColor || '#b5b5b5'} 60%,
      ${({ theme }) => theme.settings.textColor || '#b5b5b5'} 100%
    );
    background-size: 200% 100% !important;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text !important;
    display: inline-block !important;
    animation: ${chatTextShine} 3s linear infinite !important;
  }
`;
// new style
export const ThemeInput = styled(Input)`
  width: 100%;
  position: relative;
  font-size: 16px;
  border: 1px solid ${({ theme }) => theme.settings.borderColorLight};
  color: ${({ theme }) => theme.settings.secondary};
  border-radius: 10px !important;
  svg,
  img {
    color: ${({ theme }) => theme.settings.textColor};
  }
  &:hover,
  &:focus,
  &:focus-within,
  &:active,
  &:visited {
    border: 1px solid ${({ theme }) => theme.settings.primary} !important;
  }

  &.placeholderItalic {
    ::placeholder {
      font-style: italic !important;
    }
  }
  &.rounded {
    border-radius: 40px !important;
  }
  &.shadow {
    box-shadow: 0px 0px 8px rgba(50, 50, 50, 0.05);
  }
  &.grayBg {
    background: rgba(${({ theme }) => theme.settings.rgbaGray}, 0.3);
  }
  /* &&:hover,
  &&:focus,
  &&:active,
  &&:touch-action {
    border: 1px solid ${({ theme }) => theme.settings.mainColor} !important;
  } */
`;
export const XThemeSelect = styled(Select)`
  min-width: 85px;
  text-align: center;
  .ant-select-selector {
    border-radius: 20px !important;
    border: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    color: ${({ theme }) => theme.settings.primary} !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 18px !important;
    @media (max-width: 768px) {
      font-size: 12px !important;
      line-height: 16px !important;
    }
  }
  .ant-select-arrow {
    font-size: 12px !important;
    color: ${({ theme }) => theme.settings.primary} !important;
  }
  &.fullWidth {
    min-width: 100% !important;
    width: 100% !important;
    text-align: left;
    &.noRadius {
      .ant-select-selector {
        border-radius: 10px !important;
      }
    }
  }
`;
// new style
export const ThemeTag = styled(Tag)`
  font-family: ${({ theme }) =>
    theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"} !important;
  border-radius: 5px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 500;
`;
// new style
export const ThemeTableCard = styled(Card)`
  width: 100%;
  position: relative;
  height: 100%;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  background: ${({ theme }) => theme.settings.whiteColor};
  .ant-card-body {
    padding: 0px !important;
  }
  .ant-card-head {
    font-family: ${({ theme }) =>
      theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"} !important;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: ${({ theme }) => theme.settings.secondary};
    padding: 24px;
    border-bottom: none;
  }
`;
// new style
export const ThemeTable = styled(Table)`
  .ant-table,
  .ant-table-content {
    border-radius: 20px 20px 0px 0px;
  }
  &.radiusHead {
    .ant-table-cell {
      &:first-child {
        border-radius: 10px !important;
      }
      &:last-child {
        border-radius: 10px !important;
      }
    }
  }
  .ant-table-cell {
    font-family: ${({ theme }) =>
      theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"};
    font-style: normal;
    font-weight: 600 !important;
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    border-top: none !important;
    color: ${({ theme }) => theme.settings.primary} !important;
    border-radius: 0px !important;
    a {
      font-family: ${({ theme }) =>
        theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"} !important;
      color: ${({ theme }) => theme.settings.primary} !important;
      text-decoration: underline;
    }
    &:first-child {
      border-radius: 0px !important;
    }
    &:last-child {
      border-radius: 0px !important;
    }
  }
  td.ant-table-cell {
    text-transform: capitalize;
    font-weight: 400 !important;
    font-size: 12px;
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    color: ${({ theme }) => theme.settings.primary} !important;
    font-family: ${({ theme }) =>
      theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"} !important;
    &:first-child {
      border-radius: 0px !important;
    }
    &:last-child {
      border-radius: 0px !important;
    }
  }
  tr {
    &:nth-child(even) {
      td.ant-table-cell {
        background: #f9fafc !important;
      }
    }
    &:last-child {
      td.ant-table-cell {
        &:first-child {
          /* background: red !important; */
          border-radius: 0px !important;
        }
        &:last-child {
          /* background: green !important; */
          border-radius: 0px !important;
        }
      }
    }
  }
  .ant-checkbox-wrapper {
    border-color: ${({ theme }) => theme.settings.borderColor} !important;
    border-radius: 5px !important;
    .ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
      border-color: ${({ theme }) => theme.settings.primary};
    }
    .ant-checkbox-indeterminate {
      .ant-checkbox-inner {
        border-color: ${({ theme }) => theme.settings.primary} !important;
        &::after {
          background: ${({ theme }) => theme.settings.primary} !important;
          border-color: ${({ theme }) => theme.settings.primary} !important;
        }
      }
    }
    &.ant-checkbox-wrapper-checked {
      border-color: ${({ theme }) => theme.settings.primary} !important;
      .ant-checkbox-inner {
        background: ${({ theme }) => theme.settings.primary} !important;
        border-color: ${({ theme }) => theme.settings.primary} !important;
      }
    }
  }

  ul.ant-pagination {
    margin: 15px !important;
    gap: 8px;
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev {
      border-radius: 5px !important;
    }
    li.ant-pagination-item,
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev,
    .ant-pagination-prev button,
    .ant-pagination-next button {
      /* background: ${({ theme }) => theme.settings.bodyBg}; */
      background: ${({ theme }) => theme.settings.bodyBg};
      color: ${({ theme }) => theme.settings.primary};
      border-radius: 50%;
      font-weight: 600;
      font-size: 12px;
      margin: 0 !important;

      .ant-pagination-item-ellipsis {
        font-size: 8px !important;
        color: ${({ theme }) => theme.settings.primary} !important;
      }
      &:hover,
      &.ant-pagination-item-active {
        background: ${({ theme }) => theme.settings.cta_hover};
        color: ${({ theme }) => theme.settings.whiteColor} !important;
        border-color: transparent;
        a {
          color: ${({ theme }) => theme.settings.whiteColor} !important;
        }
        svg {
          color: ${({ theme }) => theme.settings.whiteColor} !important;
        }
        .ant-pagination-item-link-icon {
          color: ${({ theme }) => theme.settings.whiteColor} !important;
        }
      }
    }
    li.ant-pagination-disabled button {
      background: transparent;
      color: ${({ theme }) => theme.settings.borderColor};
      border-radius: 50%;
      font-weight: 600;
      font-size: 13px;
      &:hover {
        background: ${({ theme }) => theme.settings.gradientBg} !important;
        color: ${({ theme }) => theme.settings.primary} !important;
        border-color: ${({ theme }) => theme.settings.borderColor};
      }
    }
    .ant-select-selector {
      border-color: ${({ theme }) => theme.settings.borderColor} !important;
      font-size: 12px !important;
      line-height: 12px !important;
    }
  }

  tr.highlighted-row > td {
    background: rgba(46, 69, 218, 0.03) !important;
    border-top: 1px solid rgba(46, 69, 218, 0.5) !important;
    border-bottom: 1px solid rgba(46, 69, 218, 0.5) !important;
  }
  tr.highlighted-row > td:first-child {
    border-left: 1px solid rgba(46, 69, 218, 0.5) !important;
  }
  tr.highlighted-row > td:last-child {
    border-right: 1px solid rgba(46, 69, 218, 0.5) !important;
  }
`;
export const ThemeTablePaginationWrapper = styled.div`
  font-family: ${({ theme }) =>
    theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;

  @media (max-width: 768px) {
    display: block;
  }
  .leftWrapper {
    font-size: 12px;
    line-height: 100%;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.primary};
    @media (max-width: 768px) {
      display: none;
    }
  }
  .rightWrapper {
    font-size: 14px;
    line-height: 100%;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.primary};
    @media (max-width: 768px) {
      display: none;
    }
  }
`;

// Card view pagination wrapper - same styles as ThemeTable pagination
export const CardPaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;

  ul.ant-pagination {
    margin: 15px !important;
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev {
      border-radius: 5px !important;
    }
    li.ant-pagination-item,
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev,
    .ant-pagination-prev button,
    .ant-pagination-next button {
      background: ${({ theme }) => theme.settings.bodyBg};
      color: ${({ theme }) => theme.settings.primary};
      border-radius: 50%;
      font-weight: 600;
      font-size: 12px;

      .ant-pagination-item-ellipsis {
        font-size: 8px !important;
        color: ${({ theme }) => theme.settings.primary} !important;
      }
      &:hover,
      &.ant-pagination-item-active {
        background: ${({ theme }) => theme.settings.cta_hover};
        color: ${({ theme }) => theme.settings.whiteColor} !important;
        border-color: transparent;
        a {
          color: ${({ theme }) => theme.settings.whiteColor} !important;
        }
        svg {
          color: ${({ theme }) => theme.settings.whiteColor} !important;
        }
        .ant-pagination-item-link-icon {
          color: ${({ theme }) => theme.settings.whiteColor} !important;
        }
      }
    }
    li.ant-pagination-disabled button {
      background: transparent;
      color: ${({ theme }) => theme.settings.borderColor};
      border-radius: 50%;
      font-weight: 600;
      font-size: 13px;
      &:hover {
        background: ${({ theme }) => theme.settings.gradientBg} !important;
        color: ${({ theme }) => theme.settings.primary} !important;
        border-color: ${({ theme }) => theme.settings.borderColor};
      }
    }
    .ant-select-selector {
      border-color: ${({ theme }) => theme.settings.borderColor} !important;
      font-size: 12px !important;
      line-height: 12px !important;
    }
  }

  @media (max-width: 991.99px) {
    width: 100%;
    justify-content: center;

    ul.ant-pagination {
      width: 100%;
      margin: 12px 0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 6px 4px;

      .ant-pagination-total-text {
        flex: 0 0 100%;
        height: auto;
        margin: 0 0 4px !important;
        text-align: center;
        line-height: 20px;
      }

      > li:not(.ant-pagination-total-text):not(.ant-pagination-options) {
        margin-inline-end: 0 !important;
      }

      .ant-pagination-options {
        flex: 0 0 100%;
        margin: 4px 0 0 !important;
        display: flex;
        justify-content: center;
      }
    }
  }

  @media (max-width: 575.99px) {
    ul.ant-pagination {
      li.ant-pagination-item,
      .ant-pagination-jump-next,
      .ant-pagination-jump-prev,
      .ant-pagination-prev,
      .ant-pagination-next,
      .ant-pagination-prev button,
      .ant-pagination-next button {
        min-width: 32px;
        width: 32px;
        height: 32px;
        line-height: 32px;
      }
    }
  }
`;
export const ThemeTablePagination = styled(Pagination)`
  font-family: ${({ theme }) =>
    theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"};
  margin: 0px !important;
  .ant-pagination-jump-next,
  .ant-pagination-jump-prev {
  }
  li.ant-pagination-item,
  .ant-pagination-jump-next,
  .ant-pagination-jump-prev,
  .ant-pagination-prev button,
  .ant-pagination-next button,
  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-jump-prev {
    background: ${({ theme }) => theme.settings.whiteColor};
    color: ${({ theme }) => theme.settings.primary};
    font-weight: 600;
    font-size: 13px;
    border: 1px solid ${({ theme }) => theme.settings.borderColor};
    .ant-pagination-item-ellipsis {
      font-size: 8px !important;
      color: ${({ theme }) => theme.settings.primary} !important;
    }
    &:hover,
    &.ant-pagination-item-active {
      border-color: ${({ theme }) => theme.settings.mainColor};
      background: ${({ theme }) => theme.settings.mainColor} !important;
      color: ${({ theme }) => theme.settings.whiteColor} !important;
      border-color: transparent;
      a {
        color: ${({ theme }) => theme.settings.whiteColor} !important;
      }
      .ant-pagination-item-link-icon {
        color: ${({ theme }) => theme.settings.whiteColor} !important;
      }
    }
  }
  li.ant-pagination-disabled button {
    background: rgba(${({ theme }) => theme.settings.tagPrimary}, 0.15) !important;
    color: ${({ theme }) => theme.settings.textColor} !important;
    font-weight: 600;
    font-size: 13px;
    &:hover {
      border-color: transparent;
      background: rgba(${({ theme }) => theme.settings.tagPrimary}, 0.35) !important;
      color: ${({ theme }) => theme.settings.textColor} !important;
    }
  }
  .ant-select-selector {
    border-color: ${({ theme }) => theme.settings.borderColor} !important;
    font-size: 12px !important;
    line-height: 12px !important;
  }
  @media (max-width: 768px) {
    display: block;
    margin: 0px auto;
    text-align: center;
  }
`;
export const ThemeTableSelectPage = styled(Select)`
  font-family: ${({ theme }) =>
    theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"};
  border: none !important;
  box-shadow: none !important;
  .ant-select-selector {
    border: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
    border-radius: 10px !important;
    font-size: 12px !important;
    line-height: 12px !important;
  }
  .ant-select-arrow {
    font-size: 12px !important;
    color: ${({ theme }) => theme.settings.primary} !important;
  }
`;
// new style
export const ThemeModal = styled(Modal)`
  font-family: ${({ theme }) => theme.fonts.inter};
  width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width)} !important;
  position: relative;
  .settingsModalHeader {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .settingsModalHeaderIcon {
    width: 52px;
    height: 52px;
    flex: 0 0 52px;
  }
  .settingsModalHeaderText {
    min-width: 0;
  }
  .settingsModalHeaderTitle {
    display: block;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: ${({ theme }) => theme.settings.primary};
  }
  .settingsModalHeaderSubtitle {
    display: block;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.settings.textColor};
  }
  .ant-modal-header {
    margin-bottom: 15px;
    .ant-modal-title {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: ${({ theme }) => theme.settings.primary};
      .uploadDocumentSubTitle {
        font-size: 14px;
        font-weight: 400 !important;
        line-height: 16px;
        color: ${({ theme }) => theme.settings.textColor};
      }
    }
  }
  .ant-modal-body {
    label {
      margin: 0px;
      font-size: 12px;
      color: ${({ theme }) => theme.settings.textColor};
      font-weight: 400;
      line-height: 18px;
      display: block;
      font-family: ${({ theme }) => theme.fonts.inter};
    }
  }
  .ant-modal-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 8px;
    button {
      border-radius: 10px !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 14px !important;
      height: 40px !important;
      padding: 10px 20px !important;
      box-shadow: none !important;
      transition: all 0.2s ease;
    }
    .ant-btn + .ant-btn {
      margin-inline-start: 0 !important;
    }
    button.ant-btn-default {
      background: ${({ theme }) => theme.settings.whiteColor} !important;
      color: ${({ theme }) => theme.settings.primary} !important;
      border-color: ${({ theme }) => theme.settings.borderColor} !important;
      font-weight: 500 !important;
      &:hover {
        background: ${({ theme }) => theme.settings.cta_hover} !important;
        color: ${({ theme }) => theme.settings.whiteColor} !important;
        border-color: transparent !important;
      }
      &:active {
        transform: scale(0.95);
      }
    }
    button.ant-btn-primary {
      background: ${({ theme }) => theme.settings.cta_hover} !important;
      color: ${({ theme }) => theme.settings.whiteColor} !important;
      border-color: ${({ theme }) => theme.settings.mainColor} !important;
      &:hover {
        background: ${({ theme }) => theme.settings.whiteColor} !important;
        color: ${({ theme }) => theme.settings.mainColor} !important;
        border-color: ${({ theme }) => theme.settings.mainColor} !important;
      }
      &:active {
        transform: scale(0.95);
      }
    }
  }
  .ant-modal-content {
    border-radius: 12px !important;
    border: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    .ant-modal-close {
      svg {
        color: ${({ theme }) => theme.settings.primary} !important;
      }
      &:hover {
        svg {
          color: ${({ theme }) => theme.settings.primary} !important;
        }
      }
    }

    /* .callingHeading {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      color: ${({ theme }) => theme.settings.secondary} !important;
      text-align: center;
      margin-bottom: 10px;
      span {
        font-weight: 600;
        font-size: 14px;
        color: ${({ theme }) => theme.settings.secondary} !important;
        text-align: center;
        margin-bottom: 10px;
      }
    } */
    .uploadTitle {
      font-size: 12px;
      font-weight: 400;
      line-height: 24px;
      color: ${({ theme }) => theme.settings.secondary} !important;
    }
  }
  @media (max-width: 991.99px) {
    &.settingsModal {
      width: min(520px, calc(100vw - 32px)) !important;
      max-width: calc(100vw - 32px);
      margin: 16px auto;

      .ant-modal-content {
        display: flex;
        flex-direction: column;
        max-height: calc(100vh - 32px);
        max-height: calc(100dvh - 32px);
        padding: 20px 16px 16px;
        overflow: hidden;
      }

      .ant-modal-header {
        flex: 0 0 auto;
        margin-bottom: 16px;
        padding-inline-end: 32px;
      }

      .ant-modal-body {
        flex: 1 1 auto;
        min-height: 0;
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior: contain;
        scrollbar-width: thin;
      }

      .ant-modal-footer {
        flex: 0 0 auto;
        margin-top: 16px;
      }

      .settingsModalHeader {
        flex-direction: column;
        align-items: flex-start;
        gap: 0;
      }

      .settingsModalHeaderIcon {
        margin-bottom: 10px;
      }

      .settingsModalHeaderText {
        display: flex;
        flex-direction: column;
      }

      .settingsModalHeaderTitle {
        font-weight: 600;
        line-height: 28px;
        color: #2c2926;
      }

      .settingsModalHeaderSubtitle {
        font-weight: 500;
        line-height: 28px;
        color: #414651;
        overflow-wrap: anywhere;
      }

      .settingsModalCard,
      .settingsModalCard code {
        min-width: 0;
        overflow-wrap: anywhere;
      }

      .settingsModalCard .ant-row {
        margin-inline: 0 !important;
      }

      .settingsModalCard .ant-col {
        min-width: 0;
        padding-inline: 0 !important;
      }

      .settingsModalCard .providerOption {
        min-width: 0;
        gap: 8px;
        padding: 12px;
      }

      .settingsModalCard .providerOption > .ant-space,
      .settingsModalCard .providerOption > .ant-space > .ant-space-item:last-child {
        min-width: 0;
      }

      .settingsModalCard .providerName,
      .settingsModalCard .providerDesc {
        overflow-wrap: anywhere;
      }

      .settingsModalCard button {
        max-width: 100%;
        white-space: normal;
      }
    }
  }
`;
export const ThemeTableDropdown = styled(Dropdown)`
  font-size: 24px;
  color: ${({ theme }) => theme.settings.primary} !important;
`;
export const ThemeForm = styled(Form)`
  width: 100%;
  position: relative;
  font-family: ${({ theme }) =>
    theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"} !important;
  .labelStyle1 {
    .ant-form-item-label > label {
      font-size: 12px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      color: ${({ theme }) =>
        theme?.colors?.textColor || theme?.theme?.colors?.textColor || '#6D6A67'} !important;
    }
  }
  .labelStyle2 {
    .ant-form-item-label > label {
      font-size: 12px !important;
      font-weight: 500 !important;
      line-height: 20px !important;
      color: ${({ theme }) =>
        theme?.colors?.secondary || theme?.theme?.colors?.secondary || '#2C2926'} !important;
    }
  }
`;
export const ThemeSwitch = styled(Switch)`
  &.positionRight {
    float: right;
  }
  background: ${({ theme }) => theme.settings.bodyBg} !important;
  border-color: ${({ theme }) => theme.settings.borderColor} !important;
  &.ant-switch-checked {
    background: ${({ theme }) => theme.settings.mainColor} !important;
    border-color: ${({ theme }) => theme.settings.mainColor} !important;
  }
  /* Locked ($locked, study forms only): the !important backgrounds above hide antd's own
     disabled look (an "off" switch on the off-white card looked exactly like an editable
     one), so paint the locked state explicitly - a darker track, a muted knob and the
     not-allowed cursor. Other pages keep their switches as they were. */
  ${({ $locked }) => $locked && `
  &.ant-switch-disabled,
  &.ant-switch-disabled:hover {
    background: #cfcbc7 !important;
    border-color: #cfcbc7 !important;
    opacity: 1 !important;
    cursor: not-allowed !important;
  }
  &.ant-switch-disabled.ant-switch-checked,
  &.ant-switch-disabled.ant-switch-checked:hover {
    background: #9aa3c4 !important;
    border-color: #9aa3c4 !important;
  }
  &.ant-switch-disabled .ant-switch-handle::before {
    background: #f1efeb;
    box-shadow: none;
  }
  `}
`;
export const ThemeUploadDragDrop = styled(Dragger)`
  font-family: ${({ theme }) =>
    theme?.fonts?.inter || theme?.theme?.fonts?.inter || "'Inter', sans-serif"} !important;
  .ant-upload-drag {
    padding: 10px 0px;
    border: 1px dashed ${({ theme }) => theme.settings.mainColor} !important;
    /* border: none;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='black' stroke-width='2' stroke-dasharray='6%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e"); */
  }
  .ant-upload-drag-icon {
    color: ${({ theme }) => theme.settings.mainColor};
  }
  .iconWrapper {
    width: 100%;
    position: relative;
    text-align: center;
  }
  .uploadTitle {
    width: 100%;
    position: relative;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    color: ${({ theme }) => theme.settings.primary};
  }
`;
// new style
export const ThemeDivider = styled(Divider)`
  .ant-divider-inner-text {
    color: ${({ theme }) => theme.settings.textColor};
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-transform: uppercase;
  }
`;
/************* New Theme Components *************/
export const ThemeMainWrapper = styled(Card)`
  width: 100%;
  position: relative;
  min-height: calc(100vh - 32px);
  background-image:
    url('/images/card-wave-bg.svg'),
    linear-gradient(180deg, rgba(250, 249, 255, 0.3) 0%, rgba(250, 249, 255, 0.8) 100%) !important;
  background-size: cover, cover !important;
  background-position:
    center,
    top center !important;
  background-repeat: no-repeat, no-repeat !important;
  background-attachment: fixed !important;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  @media (max-width: 768px) {
    background: ${({ theme }) => theme.settings.whiteColor} !important;
  }
  &.noBackground {
    background-image: linear-gradient(
      180deg,
      rgba(250, 249, 255, 0.3) 0%,
      rgba(250, 249, 255, 0.8) 100%
    ) !important;
    background-size: cover, cover !important;
    background-position:
      center,
      top center !important;
    background-repeat: no-repeat, no-repeat !important;
  }
  .ant-card-body {
    padding: 20px;
    background: transparent;
  }

  &.campaign-detail-wrapper {
    background: linear-gradient(180deg, rgba(250, 249, 255, 0.5) 0%, #ffffff 100%) !important;
    border: 1px solid #edeef3;
    border-radius: 16px;
    min-height: calc(100vh - 200px);
    overflow: hidden;
    .ant-card-body {
      padding: 0;
      background: transparent;
    }
    @media (max-width: 991.99px) {
      margin-top: 68px;
      padding: 0px;
    }
  }

  &.hasHeader {
    .ant-card-head {
      padding: 10px 15px;
      background: ${({ theme }) => theme.settings.whiteColor};
      font-size: 16px;
      font-weight: 500;
      color: ${({ theme }) => theme.settings.primary};
      @media (max-width: 991.99px) {
        padding: 10px 0px;
      }
    }
  }

  // chat style here
  &.whiteBackground {
    background: transparent !important;
  }
  &.smallPadding {
    .ant-card-body {
      padding: 0px 10px 10px 10px;
    }
    .presEnterLine {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      color: ${({ theme }) => theme.settings.textColor};
      margin-top: 10px;
    }
  }
  &.insightEngine {
    overflow: visible;
  }
  &.insightEngine.messages-mode {
    overflow: hidden !important;
    height: calc(100vh - 32px) !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }
  &.insightEngine.messages-mode > .ant-card-head {
    flex: 0 0 auto !important;
  }
  &.insightEngine.messages-mode > .ant-card-body {
    flex: 1 1 0 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }
  &.insightEngine.messages-mode .insight-content-wrapper {
    flex: 1 1 0 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }
  &.insightEngine.messages-mode .insight-content-wrapper > .ant-row {
    flex: 1 1 0 !important;
    min-height: 0 !important;
    align-items: stretch !important;
    overflow: hidden !important;
  }
  &.insightEngine.messages-mode .insight-content-wrapper > .ant-row > .ant-col {
    min-height: 0 !important;
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }
  &.insightEngine.messages-mode .insight-content-wrapper > .ant-row > .ant-col > div:first-child {
    flex: 1 1 0 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }
  &.insightEngine.messages-mode .insight-content-wrapper > .ant-row > .ant-col > div:first-child > .scrollable {
    flex: 1 1 0 !important;
    min-height: 0 !important;
    height: auto !important;
    overflow-y: auto !important;
  }
  &.insightEngine.messages-mode .insight-composer-footer {
    flex: 0 0 auto !important;
    padding-top: 10px;
  }
  &.insightEngine.messages-mode .insight-composer-footer .presEnterLine {
    text-align: center;
  }
  &.insightEngine .ant-card-actions > li > span {
    cursor: default;
  }
  .ant-card-actions {
    display: block;
    border-top: none !important;
    padding: 5px 15px 15px 15px;
    background: transparent !important;
    li {
      width: 100%;
      margin: 0px !important;
      list-style: none;
    }
  }
  .scrollable {
    height: calc(100vh - 200px);
    padding: 15px 15px 0px 15px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.settings.borderColor};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.primary};
    }
    &::-webkit-scrollbar-corner {
      background: ${({ theme }) => theme.settings.borderColor};
    }
    h6 {
      margin: 0px;
      font-size: 14px !important;
      font-weight: 600;
      line-height: 22px;
      color: ${({ theme }) => theme.settings.primary};
      svg {
        float: left;
        margin-right: 5px;
      }
    }
    p {
      margin-bottom: 15px;
      font-size: 14px !important;
      font-weight: 400;
      line-height: 22px;
      color: ${({ theme }) => theme.settings.primary};
    }
    ul {
      li {
        list-style: disc;
        margin-left: 15px;
        margin-bottom: 15px;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        color: ${({ theme }) => theme.settings.primary};
        span {
          font-weight: 600;
        }
      }
    }
  }

  @media (max-width: 991.99px) {
    background: ${({ theme }) => theme.settings.whiteColor};
    border: none;
    border-radius: 0px;
    margin: 0px;
    padding: 60px 0px 20px 0px;
    .ant-card-body {
      padding: 0px;
    }
    &.insightEngine {
      width: 100%;
      max-width: 100%;
      min-width: 0;
    }
    &.insightEngine.messages-mode {
      height: calc(100vh - 32px) !important;
      height: calc(100dvh - 32px) !important;
      max-height: calc(100vh - 32px) !important;
      max-height: calc(100dvh - 32px) !important;
      min-width: 0;
      padding-bottom: 0;
    }
    &.insightEngine.messages-mode > .ant-card-body {
      width: 100%;
      min-height: 0 !important;
      overflow: hidden !important;
      overscroll-behavior: none;
    }
    &.insightEngine.messages-mode .insight-content-wrapper {
      width: 100%;
      min-height: 0 !important;
      overflow: hidden !important;
    }
    &.insightEngine.messages-mode .insight-content-wrapper > .ant-row {
      width: 100%;
      flex: 1 1 0 !important;
      min-height: 0 !important;
      margin-inline: 0 !important;
      overflow: hidden !important;
    }
    &.insightEngine.messages-mode .insight-content-wrapper > .ant-row > .ant-col {
      min-width: 0;
      min-height: 0 !important;
      overflow: hidden;
    }
    &.insightEngine.messages-mode .scrollable {
      min-width: 0;
      min-height: 0 !important;
      height: auto !important;
      padding: 12px 10px 16px !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
      overscroll-behavior-x: none;
      overscroll-behavior-y: contain;
      -webkit-overflow-scrolling: touch;
      touch-action: pan-y;
      scroll-padding-block: 12px;
    }
    &.insightEngine.messages-mode .messageContainer,
    &.insightEngine.messages-mode .messageContainer > div,
    &.insightEngine.messages-mode .messageText {
      min-width: 0;
      max-width: 100%;
      overflow-wrap: anywhere;
    }
    &.insightEngine.messages-mode .messageText {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
    &.insightEngine.messages-mode .insight-composer-footer {
      position: relative;
      flex: 0 0 auto !important;
      width: 100%;
      padding: 8px 0 calc(8px + env(safe-area-inset-bottom, 0px));
      background: rgba(255, 255, 255, 0.96);
      z-index: 2;
    }
    &.insightEngine.messages-mode .insight-composer-footer > .ant-row {
      width: 100%;
      margin-inline: 0 !important;
    }
    &.insightEngine.messages-mode .insight-chat-composer {
      width: 100%;
      max-width: 100%;
      min-height: 48px;
      padding: 10px 52px 10px 14px;
      border-radius: 18px;
    }
    &.insightEngine.messages-mode .insight-chat-composer textarea {
      max-height: 88px !important;
      overflow-y: auto !important;
      overscroll-behavior: contain;
    }
    &.insightEngine.messages-mode .insight-chat-input-box {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      margin-top: 8px;
    }
    &.insightEngine.messages-mode .insight-chat-input-box > div:first-child {
      min-height: 104px;
      padding: 14px 16px 50px;
    }
    &.insightEngine.messages-mode .insight-chat-input-box textarea {
      max-height: 66px !important;
      overflow-y: auto !important;
      overscroll-behavior: contain;
    }
    &.insightEngine.messages-mode .insight-scroll-controls {
      right: 8px !important;
      bottom: 8px !important;
    }
    &.insightEngine.hasHeader > .ant-card-head {
      min-height: 0;
      padding: 8px 0;
    }
    &.insightEngine.hasHeader > .ant-card-head .ant-card-head-wrapper {
      align-items: center;
      gap: 10px;
      min-width: 0;
    }
    &.insightEngine.hasHeader > .ant-card-head .ant-card-head-title {
      min-width: 0;
      padding: 0;
      overflow: hidden;
    }
    &.insightEngine.hasHeader > .ant-card-head .ant-card-head-title > .ant-space {
      max-width: 100%;
      min-width: 0;
    }
    &.insightEngine.hasHeader > .ant-card-head .ant-card-extra {
      min-width: 0;
      max-width: 55%;
      margin: 0;
      padding: 0;
      overflow: hidden;
    }
    &.insightEngine.hasHeader > .ant-card-head .ant-card-extra > .ant-space {
      display: flex;
      max-width: 100%;
      gap: 6px !important;
      overflow-x: auto;
      scrollbar-width: none;
    }
    &.insightEngine.hasHeader > .ant-card-head .ant-card-extra > .ant-space::-webkit-scrollbar {
      display: none;
    }
    &.insightEngine.hasHeader > .ant-card-head .ant-btn {
      flex: 0 0 auto;
      height: 34px;
      padding-inline: 10px;
      font-size: 12px !important;
    }
    &.insightEngine .insight-content-wrapper,
    &.insightEngine .insight-composer-footer {
      width: 100%;
      min-width: 0;
      max-width: 100%;
    }
    &.insightEngine .insight-content-wrapper > .ant-row > .ant-col,
    &.insightEngine .insight-composer-footer > .ant-row > .ant-col {
      flex: 0 0 100% !important;
      max-width: 100% !important;
      margin-inline-start: 0 !important;
    }
    &.genzSignalsLanding {
      height: calc(100vh - 32px) !important;
      height: calc(100dvh - 32px) !important;
      min-height: 0 !important;
      max-height: calc(100vh - 32px) !important;
      max-height: calc(100dvh - 32px) !important;
      display: flex;
      flex-direction: column;
      overflow: hidden !important;
    }
    &.genzSignalsLanding > .ant-card-head {
      flex: 0 0 auto;
    }
    &.genzSignalsLanding > .ant-card-body {
      flex: 1 1 0;
      height: auto !important;
      min-height: 0;
      overflow: hidden !important;
    }
    &.genzSignalsLanding .genz-signals-landing-content {
      min-height: 0;
      height: 100% !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
      overscroll-behavior: contain;
      scrollbar-width: thin;
      padding-left: 0 !important;
      padding-right: 0 !important;
      padding-bottom: 28px !important;
    }
  }
  @media (max-width: 575.99px) {
    &.insightEngine.hasHeader > .ant-card-head .ant-card-head-wrapper {
      display: block;
    }
    &.insightEngine.hasHeader > .ant-card-head .ant-card-extra {
      width: 100%;
      max-width: 100%;
      margin-top: 8px;
    }
    &.insightEngine.hasHeader > .ant-card-head .ant-card-extra > .ant-space {
      width: 100%;
      justify-content: flex-start;
    }
    &.insightEngine .insight-content-wrapper > .ant-row > .ant-col[style*="padding-right: 62"],
    &.insightEngine .insight-composer-footer .ant-col[style*="padding-right: 62"] {
      padding-right: 0 !important;
    }
    &.insightEngine.messages-mode .scrollable {
      padding: 8px 4px 12px !important;
    }
    &.insightEngine.messages-mode .insight-composer-footer {
      padding: 6px 0 calc(6px + env(safe-area-inset-bottom, 0px));
    }
    &.insightEngine.messages-mode .insight-chat-composer {
      min-height: 46px;
      padding: 9px 48px 9px 12px;
      border-radius: 16px;
    }
    &.insightEngine.messages-mode .insight-chat-composer textarea,
    &.insightEngine.messages-mode .insight-chat-input-box textarea {
      font-size: 16px !important;
      line-height: 21px !important;
    }
    &.insightEngine.messages-mode .insight-chat-composer textarea {
      max-height: 72px !important;
    }
    &.insightEngine.messages-mode .insight-chat-input-box {
      margin-top: 6px;
    }
    &.insightEngine.messages-mode .insight-chat-input-box > div:first-child {
      min-height: 92px;
      padding: 12px 14px 46px;
    }
    &.insightEngine.messages-mode .insight-chat-input-box textarea {
      max-height: 54px !important;
    }
    &.insightEngine.messages-mode .insight-composer-footer .presEnterLine {
      margin-top: 6px;
      font-size: 10px;
      line-height: 14px;
    }
  }
`;
export const ThemeNoSidebarWrapper = styled.div`
  width: 100%;
  position: relative;
  padding: 20px;
  min-height: 100vh;
`;

export const ThemePopConfirm = styled.div`
  .ant-popconfirm {
    .ant-popconfirm-buttons {
      .ant-btn {
        border-radius: 6px !important;
        font-weight: 500 !important;
        transition: all 0.2s ease !important;
      }

      /* Cancel button (No) */
      .ant-btn-default {
        border: 1px solid ${({ theme }) => theme.settings.primary} !important;
        color: ${({ theme }) => theme.settings.primary} !important;
        background: ${({ theme }) => theme.settings.whiteColor} !important;

        &:hover {
          background: rgba(36, 58, 184, 0.05) !important;
          border-color: ${({ theme }) => theme.settings.primary} !important;
          color: ${({ theme }) => theme.settings.primary} !important;
        }
      }

      /* Confirm button (Yes) */
      .ant-btn-primary {
        background: ${({ theme }) => theme.settings.primary} !important;
        border-color: ${({ theme }) => theme.settings.primary} !important;
        color: ${({ theme }) => theme.settings.whiteColor} !important;

        &:hover {
          background: #243AB8 !important;
          border-color: #243AB8 !important;
        }
      }
    }

    .ant-popconfirm-title {
      color: ${({ theme }) => theme.settings.primary} !important;
      font-weight: 600 !important;
    }

    .ant-popconfirm-description {
      color: ${({ theme }) => theme.settings.textColor} !important;
    }
  }
`;
export const ThemeRadio = styled(Radio)`
  .ant-radio-wrapper {
    &:hover {
      .ant-radio-inner {
        border-color: ${({ theme }) => theme.settings.primary} !important;
      }
    }
  }
  .ant-radio-checked {
    .ant-radio-inner {
      background-color: ${({ theme }) => theme.settings.primary} !important;
      border-color: ${({ theme }) => theme.settings.primary} !important;
    }
    &::after {
      border: 1px solid ${({ theme }) => theme.settings.primary} !important;
    }
  }
  /* .ant-radio-button-wrapper-checked {
    background: ${({ theme }) => theme.settings.primary} !important;
    border-color: ${({ theme }) => theme.settings.primary} !important;
    color: ${({ theme }) => theme.settings.whiteColor} !important;
  } */
`;
export const ThemeCheckbox = styled(Checkbox)`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #000 !important;
  text-decoration: none;
  text-decoration: none !important;
  .ant-checkbox-checked {
    .ant-checkbox-inner {
      background: ${({ theme }) => theme.settings.mainColor} !important;
      border-color: ${({ theme }) => theme.settings.mainColor} !important;
    }
  }
  &:hover {
    .ant-checkbox-inner {
      border-color: ${({ theme }) => theme.settings.mainColor} !important;
    }
  }
`;
export const ThemeDrawer = styled(Drawer)`
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  .ant-drawer-body {
    &::-webkit-scrollbar {
      width: 1px;
      height: 2px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.primary};
    }
    &::-webkit-scrollbar-corner {
      background: ${({ theme }) => theme.settings.borderColor};
    }
  }
  .ant-drawer-title {
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.settings.primary};
  }
  .para1 {
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.textColor};
  }
  .heading {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
  }
`;
export const ThemeUserManagementTabs = styled(Tabs)`
  width: 100%;
  position: relative;
  background: ${({ theme }) => theme.settings.whiteColor} !important;
  border-radius: 10px !important;
  .ant-card {
    background: transparent !important;
  }
  .customContainer {
    padding: 20px !important;
  }
  .ant-tabs-content-holder {
    border: 1px solid #f0f0f0 !important;
    border-top: none !important;
  }
  .ant-tabs-nav {
    margin: 0px !important;
  }
  .ant-tabs-tab {
    background: #f0f0f0 !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 16px !important;
    &:hover {
      background: ${({ theme }) => theme.settings.cta_hover} !important;
      .ant-tabs-tab-btn {
        color: ${({ theme }) => theme.settings.whiteColor} !important;
      }
    }
  }
  .ant-tabs-tab-active {
    background: ${({ theme }) => theme.settings.cta_hover} !important;
    .ant-tabs-tab-btn {
      color: ${({ theme }) => theme.settings.whiteColor} !important;
    }
  }
  @media (max-width: 768px) {
    > .ant-tabs-nav .ant-tabs-tab {
      margin: 0 2px 0 0 !important;
      padding: 9px 12px !important;
      font-size: 14px !important;
      line-height: 18px !important;
    }

    > .ant-tabs-nav .ant-tabs-nav-more {
      padding: 9px 10px !important;
    }
  }
  @media (max-width: 480px) {
    > .ant-tabs-nav .ant-tabs-tab {
      padding: 8px 10px !important;
      font-size: 12px !important;
      line-height: 18px !important;
    }

    > .ant-tabs-nav .ant-tabs-nav-more {
      padding: 8px !important;
      font-size: 12px !important;
    }
  }
  .customBorders {
    border-top: 1px solid #f0f0f0 !important;
  }
`;
